import { useMemo } from 'react';
import { WsDataTable } from 'wisestep-base';

import InvitedUserType from '../types';

import { ListHeader } from './ListHeader';

interface ICurrentInvitesListProps {
  usersList: InvitedUserType[];
}

const CurrentInvitesList = ({ usersList }: ICurrentInvitesListProps) => {
  const columns = useMemo(() => ListHeader, []);
  const data = useMemo(
    () =>
      usersList.map((row) => ({
        email: row.email,
        role: row.role,
        downloadAccess: row.downloadAccess,
        status: row.status,
      })),
    [usersList]
  );
  return <WsDataTable columns={columns} data={data} elevated={false} />;
};

export default CurrentInvitesList;
